<div class="welcomeCard">
  <button
    type="button"
    class="welcome-close"
    (click)="closeModal()"
    [attr.aria-label]="'AUTH.WELCOME.CLOSE' | translate"
  >
    <i class="pi pi-times"></i>
  </button>

  <div class="welcome-glow"></div>

  <div class="welcome-icon">
    <i class="pi pi-check"></i>
  </div>

  <h3 class="welcome-title">
    {{ (credentials ? "AUTH.WELCOME.CREDS_TITLE" : "AUTH.WELCOME.TITLE") | translate }}
  </h3>
  <p class="welcome-body">
    {{ (credentials ? "AUTH.WELCOME.CREDS_SUB" : "AUTH.WELCOME.BODY") | translate }}
  </p>

  <!-- Credentials mode (one-click): the ONLY place the generated password
       is shown — save actions are front and center -->
  <div class="welcome-creds" *ngIf="credentials">
    <div class="creds-row">
      <span class="creds-label">{{ "AUTH.INPUT.USERNAME" | translate }}</span>
      <span class="creds-value">{{ credentials.username }}</span>
    </div>
    <div class="creds-row">
      <span class="creds-label">{{ "AUTH.INPUT.PASSWORD" | translate }}</span>
      <span class="creds-value">
        {{ passwordDisplay }}
        <button
          type="button"
          class="creds-eye"
          (click)="showPassword = !showPassword"
          [attr.aria-label]="'AUTH.INPUT.PASSWORD' | translate"
        >
          <i class="pi" [ngClass]="showPassword ? 'pi-eye-slash' : 'pi-eye'"></i>
        </button>
      </span>
    </div>

    <div class="creds-save">
      <button type="button" (click)="saveToFile()">
        <i class="pi pi-download"></i>
        {{ "AUTH.WELCOME.SAVE_FILE" | translate }}
      </button>
      <button type="button" (click)="saveToImage()">
        <i class="pi pi-image"></i>
        {{ "AUTH.WELCOME.SAVE_PICTURE" | translate }}
      </button>
    </div>

    <small class="creds-hint">
      <i class="pi pi-exclamation-triangle"></i>
      {{ "GENERAL.PLEASE_KEEP_THESE_INFORMATION_SAFE" | translate }}
    </small>
  </div>

  <div class="welcome-actions">
    <button type="button" class="btn-deposit" (click)="depositNow()">
      <i class="pi pi-wallet"></i>
      {{ "AUTH.WELCOME.DEPOSIT_NOW" | translate }}
    </button>
    <button type="button" class="btn-close-secondary" (click)="closeModal()">
      {{ "AUTH.WELCOME.CLOSE" | translate }}
    </button>
  </div>
</div>

<!-- Off-screen render target for the save-to-picture export -->
<div
  *ngIf="credentials"
  id="welcomeCredsImage"
  style="
    background-color: black;
    padding: 30px;
    font-family: Arial, sans-serif;
    position: absolute;
    top: -99999999px;
    left: -9999999px;
    width: 360px;
  "
>
  <div style="text-align: center; margin-bottom: 20px">
    <img
      alt="Racebet365"
      src="assets/media/logos/racebet365.png"
      width="200"
      style="max-width: 100%"
    />
  </div>
  <div style="background-color: black; padding: 20px; border-radius: 8px">
    <div style="margin-bottom: 15px; font-size: 16px; color: white">
      <strong>Username:</strong> {{ credentials.username }}
    </div>
    <div style="font-size: 16px; color: white">
      <strong>Password:</strong> {{ credentials.password }}
    </div>
  </div>
  <div style="text-align: center; margin-top: 20px; font-size: 12px; color: white">
    {{ "GENERAL.PLEASE_KEEP_THESE_INFORMATION_SAFE" | translate }}
  </div>
</div>
